var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ejs-querybuilder',{ref:"querybuilder",attrs:{"ruleChange":_vm.filterChanged,"columns":_vm.currentFilterFields,"locale":_vm.$config.currentLocale,"maxGroupCount":_vm.maxGroupCount}})
}
var staticRenderFns = []

export { render, staticRenderFns }